export default __webpack_public_path__ + "static/media/IF_MyStrengths_StrengthDesc_03.7a0ee9ff.jpg";